import { render, staticRenderFns } from "./GoodsSettingCustomBuyBtn.vue?vue&type=template&id=6252b46e&scoped=true"
import script from "./GoodsSettingCustomBuyBtn.vue?vue&type=script&lang=js"
export * from "./GoodsSettingCustomBuyBtn.vue?vue&type=script&lang=js"
import style0 from "./GoodsSettingCustomBuyBtn.vue?vue&type=style&index=0&id=6252b46e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6252b46e",
  null
  
)

export default component.exports